module.exports = __webpack_public_path__ + "img/right_angle_corner_arrow_line_icon.6034eb30.svg";